import firebase from "../helper/firebase";

const initialState = {
  settings: {},
  settingsLoading: true,

  snack: false,
  snackMessage: ""
};

//Actions
const UNAUTHENTICATED = "GlobalState/UNAUTHENTICATED";
const GET_SETTINGS = "UserState/GET_SETTINGS";
const SET_SNACK = "GlobalState/SET_SNACK";

export function getSettings(uid) {
  return (dispatch, getState) => {
    firebase.database().ref(`settings/${uid}`).on('value',snap=>{
      if(snap.val()!==null){
        dispatch({ type: GET_SETTINGS, payload: snap.val() });
      }
      else{
        dispatch({ type: GET_SETTINGS, payload: {} });
      }
    },err=>{
      // console.log(err);
      // dispatch(setSnack(true,'Error: Please try again.'));
    })
  }
}

export function setSnack(snackStatus, snackMessage) {
  return (dispatch, getState) => {
    let snack = { snackStatus, snackMessage };
    dispatch({ type: SET_SNACK, payload: snack });
  };
}


export function setSettingsListener() {
  return (dispatch, getState) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch(getSettings(user.uid))
      } else {
        // dispatch({ type: UNAUTHENTICATED });
      }
    });
  };
}

export default (state = initialState, action) => {
  switch (action.type) {
    case UNAUTHENTICATED:
      return {
        ...initialState,
      };

    case GET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
        settingsLoading: false
      };

    case SET_SNACK:
      return {
        ...state,
        snackStatus: action.payload.snackMessage,
        snackMessage: action.payload.snackMessage
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/SettingsReducer.js